import { Form, Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
    CallBackConfigPagedList,
    CallBackConfigPayload,
    getCallBackSourceServiceConfigs,
    MstRequest,
} from 'api/master';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';

//let payPagedList: CallBackConfigPagedList;
//let callbackconfigpayload: CallBackConfigPayload;

type Props = {
    filter: MstRequest;
    onSubmit: (values: CallBackConfigPayload) => Promise<void>;
};

// 👈 1. FIXED: Initialized default fallback object to prevent 'undefined' component unmount loops
const initialPagedList: CallBackConfigPagedList = {
    data: [],
    noOfRecords: 0,
    currentPageIndex: 1,
};

const Callbacklist = ({ filter }: Props) => {
    const [_form] = Form.useForm<CallBackConfigPayload>();
    const [pagedList, setPagedList] = useState<CallBackConfigPagedList>(initialPagedList);
    //const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    //   const [isModalLoading] = useState(false);
    const [_isRetry] = useState(false);

    const isFetchingRef = useRef(false);
    const lastFilterRef = useRef('');

    filter.userName = sessionStorage.getItem('user')?.toString();
    //const isAdmin = sessionStorage.getItem('isAdmin');

    useEffect(() => {
        const sessionUser = sessionStorage.getItem('user')?.toString();
        const requestPayload: MstRequest = {
            ...filter,
            userName: sessionUser,
            pageNo: 1,
            pageSize: 10,
        };

        const filterStr = JSON.stringify(requestPayload);

        // Lock check: stop duplicate calls if identical payload or request in-flight
        if (lastFilterRef.current === filterStr || isFetchingRef.current) {
            return;
        }

        lastFilterRef.current = filterStr;
        isFetchingRef.current = true;

        setIsLoading(true);
        //  setPagedList(payPagedList);

        // filter.pageNo = 1;
        // filter.pageSize = 10;

        getCallBackSourceServiceConfigs(requestPayload)
            .then((res) => {
                setPagedList(res.data);
            })
            .finally(() => {
                setIsTableLoading(false);
                isFetchingRef.current = false;
            });
    }, [JSON.stringify(filter)]);


    // const handleRetry = (record: PaymentListData) => {
    //     setIsLoading(true);
    //     retry(record.PAYMENTREQUESTID)
    //         .then((res) => {
    //             setRetryRes(res);

    //             if (res.responseCode == '200') {
    //                 message.success('Done Successfully!');
    //                 setIsLoading(false);
    //             } else {
    //                 message.error(res.message);
    //             }
    //         })
    //         .finally(() => {
    //             setRetry(!_isRetry);
    //         });
    // };

    const columns: ColumnsType<CallBackConfigPayload> = [
        {
            key: 'sourceName',
            title: 'Source Application Name',
            dataIndex: 'sourceName',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
            className: '',
        },
        {
            key: 'serviceName',
            title: 'Callback Service',
            dataIndex: 'serviceName',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'callbackURL',
            title: 'Callback URL',
            dataIndex: 'callbackURL',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'headers',
            title: 'Header',
            dataIndex: 'headers',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'createdOn',
            title: 'CreatedOn',
            dataIndex: 'createdOn',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={moment(record).format('DD/MM/YYYY HH:mm:ss')}>
                    {moment(record).format('DD/MM/YYYY HH:mm:ss')}
                </Tooltip>
            ),
        },
        {
            key: 'createdBy',
            title: 'CreatedBy',
            dataIndex: 'createdBy',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'flag',
            title: 'Flag',
            dataIndex: 'flag',
            ellipsis: true,
            render: flag => flag ? 'Active' : 'InActive',
        },
    ];

    if (!pagedList || !isLoading) {
        return <LoadingScreen />;
    }


    const handleChange = (_pagination: any, _filters: CallBackConfigPayload) => {
        //setIsLoading(false);
        setIsTableLoading(true);

        const sessionUser = sessionStorage.getItem('user')?.toString();
        const paginationPayload: MstRequest = {
            ...filter,
            userName: sessionUser,
            pageNo: _pagination.current,
            pageSize: _pagination.pageSize,
        };

        // filter.pageNo = _pagination.current;
        // filter.pageSize = _pagination.pageSize;

        getCallBackSourceServiceConfigs(paginationPayload).then((res) => {
            setPagedList(res.data);
            //setIsLoading(true);
        })
            .finally(() => {
                setIsTableLoading(false);
            });
        // });
    };

    const maxWidthPerCell = 1000;

    const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
    const tableHeight = 500;
    const rowKey = 'ROWNUM';

    return (
        <>
            <Spin spinning={isTableLoading}>
                <Table
                    columns={dataTable.columns}
                    dataSource={dataTable.source}
                    rowKey={rowKey}
                    scroll={{ x: dataTable.tableWidth, y: tableHeight }}
                    pagination={{
                        pageSize: 10,
                        total: pagedList.noOfRecords,
                        current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
                    }}
                    onChange={handleChange}
                />
            </Spin>
            ;
        </>
    );
};

export default Callbacklist;
